import {get} from '@/services/infrastructure/api.service'
import {Organization} from '@/organization/Organization'
import emitter from '@/services/infrastructure/emitter'
import {LOGOUT, NO_ORG_SELECTED, ORG_SELECTED, ORG_SWITCHED} from '@/types/events'
import {ref} from 'vue'

export const organization = ref<Organization | undefined>()
const ORGANIZATION_UPDATED = 'organizationUpdated'

const getOrganization = async () => get<Organization>('/organization')

const clear = () => {
    organization.value = undefined
}

const fetchOrganization = async () => {
    organization.value = await getOrganization()
}

emitter.on(ORGANIZATION_UPDATED, fetchOrganization)
emitter.on(ORG_SWITCHED, fetchOrganization)
emitter.on(ORG_SELECTED, fetchOrganization)
emitter.on(NO_ORG_SELECTED, clear)
emitter.on(LOGOUT, clear)
